import { initiateGam } from '@client/adManager/initiateGam.js';
import { $config } from '@client/core/atoms/config.js';
import {
  getInterminglePlacements,
  getPlacementList,
  updatePlacementStatuses
} from '@client/core/atoms/placements.js';
import { $retailMediaAtom } from '@client/core/atoms/retailMedia.js';
import { setupTravelEvents } from '@client/core/utils/events/setupTravelEvents.js';
import { events, messageBus } from '@schibsted-nmp/advertising-events';
import {
  debugLog,
  type LayoutType,
  PageType,
  Vertical
} from '@schibsted-nmp/advertising-shared';

import {
  initializeFilterCollisionDetection,
  disconnectFilterObserver
} from '../dom/handleAdsOverlap/filterCollisionDetection.js';
import { isMiddlePlacement } from '../placement.js';
import { refreshKeywords } from '../refreshKeywords.js';

let cleanupHandler: (() => void) | null = null;

export function setupEvents() {
  const { pageType, vertical } = $config.get() ?? {};

  if (cleanupHandler) {
    window.removeEventListener('pagehide', cleanupHandler);
    cleanupHandler = null;
  }

  // Keep this for backward compatibility
  const interminglePlacements = getInterminglePlacements();

  debugLog('placementsWithIntermingle: ', interminglePlacements);

  if (interminglePlacements.length > 0) {
    messageBus.publish('advertising-podlet', 'podlet-ready', {
      placementsWithIntermingle: interminglePlacements
    });
  }

  if (vertical === Vertical.Travel) {
    setupTravelEvents();
  } else if (pageType === PageType.Result) {
    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.FILTER.topic,
      refreshKeywords.sync
    );

    messageBus.subscribe('search', 'layout', (event) => {
      const { payload } = event as { payload: { layout: LayoutType } };

      $retailMediaAtom.set({
        ...$retailMediaAtom.get(),
        layoutType: payload.layout,
        eventType: 'layout_change'
      });

      const middlePlacements = getPlacementList().filter((placement) =>
        isMiddlePlacement(placement.placementId)
      );
      updatePlacementStatuses(middlePlacements, 'refresh');
    });

    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.EXPANDABLE_UPDATE.topic,
      () => {
        // ? EXPANDABLE_UPDATE event is not coming through, we didn't investigate why.
        // Keeping it here in case we want to fix and use it in the future.
        // For now, collision detection is handled via ResizeObserver in initializeFilterCollisionDetection instead.
        // checkMiddleBannerCollisions();
      }
    );

    initializeFilterCollisionDetection();

    cleanupHandler = () => {
      disconnectFilterObserver();
    };

    window.addEventListener('pagehide', cleanupHandler);
  }

  if (pageType === PageType.Object) {
    messageBus.subscribe(
      events.ITEM_PAGE.channel,
      events.ITEM_PAGE.INCAROUSEL_IMAGE_UPDATE.topic,
      initiateGam.handleInCarouselImageUpdate
    );
  }
}
